import { inject } from "ui-common/di";
import type { IWritableBackofficeFeatureFlagsState, IBackofficeFeatureFlagsService } from "./types";
import type { IRpcService } from "ui-common/services/rpc/types";
import type { IAuthProvider } from "ui-common/services/auth/types";
import type { GetMyFeatureFlagsResult } from "api-contracts/rpc/feature-flags";

export class BackofficeFeatureFlagsService implements IBackofficeFeatureFlagsService {
  @inject<IWritableBackofficeFeatureFlagsState>("writableBackofficeFeatureFlagsState")
  private state!: IWritableBackofficeFeatureFlagsState;

  @inject<IRpcService>("rpcService")
  private rpcService!: IRpcService;

  @inject<IAuthProvider>("authProvider")
  private authProvider!: IAuthProvider;

  private pendingLoad: Promise<void> | undefined;

  loadFlags(): void {
    if (!this.authProvider.isAuthenticated()) return;
    if (this.pendingLoad) return;

    this.state.loading.set(true);
    this.pendingLoad = this.doLoad();
  }

  reload(): void {
    this.pendingLoad = undefined;
    this.state.loading.set(true);
    this.pendingLoad = this.doLoad();
  }

  private async doLoad(): Promise<void> {
    try {
      const result = await this.rpcService.call<GetMyFeatureFlagsResult>("get-my-feature-flags", {});
      this.state.features.set(result.features);
    } catch (error) {
      console.error("[BackofficeFeatureFlagsService] Error loading feature flags:", error);
    } finally {
      this.state.loading.set(false);
      this.pendingLoad = undefined;
    }
  }
}
